module.exports = __webpack_public_path__ + "files/93f47238243fbe0725a14f09c61cbc49.png";